import { mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { selectedDetailsItemAtom, showDetailsDrawerAtom } from '@/store/tasksApprovals/detailsDrawer'
import { getInfoIcon } from '@/store/tasksApprovals/utils'
import { IApproval } from '@/types/tasksApprovals'
import { isSailPointCert, isSailPointCertDecision, isServiceNowChangeRequests } from '@/utils/approvals'

import Status from './components/status'

const ApprovalItem = ({ icon, item }: { icon: JSX.Element; item: IApproval }) => {
    const [, setDetailsItem] = useAtom(selectedDetailsItemAtom)
    const [, showDetailsDrawer] = useAtom(showDetailsDrawerAtom)
    const iconColor = useColorModeValue('var(--chakra-color-dark-700)', 'rgba(255, 255, 255, 0.3)')
    const textColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')
    const { t } = useTranslation()

    const onClick = () => {
        setDetailsItem(item)
        showDetailsDrawer(true)
    }

    return (
        <Flex
            alignItems={['flex-start', 'flex-start', 'center']}
            justifyContent="space-between"
            borderBottom="1px solid"
            borderColor="rgba(84, 79, 64, 0.12)"
            cursor="pointer"
            onClick={onClick}
            flexDir={['column', 'column', 'row']}
            padding="16px 0"
        >
            <Flex alignItems="center">
                <Box p="0 16px 0 8px">{icon}</Box>
                <Box>
                    <Text fontWeight="bold" fontSize="14px" lineHeight="20px" wordBreak="break-word">
                        {isSailPointCert(item) || isSailPointCertDecision(item) ? item.description : item.requester_name}
                    </Text>
                    {!isSailPointCert(item) && !isSailPointCertDecision(item) && !isServiceNowChangeRequests(item) && (
                        <Text fontSize="14px" lineHeight="20px" color={textColor} wordBreak="break-all">
                            {item.description}
                        </Text>
                    )}
                    {(isSailPointCert(item) || isServiceNowChangeRequests(item)) && <Status item={item} />}
                </Box>
            </Flex>

            <Flex
                flexDir="row"
                justifyContent={['space-between', 'space-between', 'flex-start']}
                alignItems="center"
                pr={['0', '0', '12px']}
                pl={['50px', '50px', '40px']}
                pt={['8px', '8px', '0']}
                width={['100%', '100%', 'auto']}
            >
                <Flex minW={['auto', 'auto', '170px']}>
                    {getInfoIcon(item.waitingFor, 'waiting')}

                    <Text
                        pl="8px"
                        pr={['0', '0', '22px']}
                        fontSize="14px"
                        lineHeight="20px"
                        color={textColor}
                        textAlign={['left', 'left', 'right']}
                    >
                        {t('tasksApprovals.approvals.waiting', { count: item.waitingFor < 1 ? 0 : Math.round(item.waitingFor) })}
                    </Text>
                </Flex>

                <Icon path={mdiChevronRight} size="20px" color={iconColor} />
            </Flex>
        </Flex>
    )
}

export default ApprovalItem
